import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Loading } from 'notiflix/build/notiflix-loading-aio';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';

function FetchNews() {

    const [news, setNews] = useState([]);
    const [search, setSearch] = useState('');
    const [shopType, setShopType] = useState('2'); // Default: Beerbar first

    const fetchAPI = () => {
        Loading.arrows('Loading Records...');
        axios.get(`http://online.pranaliinfotech.com/pigateway/api/OnlineCustomer/onlineCustomerRecords?i=WEB_PIGATEWAY_LOGIN&shop_type=${shopType}`)
            .then((response) => {
                setNews(response.data.online || []);
                Loading.remove();
            })
            .catch((error) => {
                console.error('API Error:', error);
                Loading.remove();
            });
    };

    useEffect(() => {
        fetchAPI();
    }, [shopType]);

    const formatDate = (isoString) => {
        if (!isoString) return '-';
        const date = new Date(isoString);
        return date.toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    // ✅ Step 1: Filter out records with missing/empty tran_date
    let filteredNews = news.filter(
        (item) =>
            item.tran_date && item.tran_date.trim() !== '' // only include non-empty date
    );

    // ✅ Step 2: Sort by tran_date (oldest first)
    filteredNews = filteredNews.sort((a, b) => new Date(a.tran_date) - new Date(b.tran_date));

    // ✅ Step 3: Apply search filter
    filteredNews = filteredNews.filter((item) =>
        item.SHOP_NAME?.toLowerCase().includes(search.toLowerCase()) ||
        item.NAME?.toLowerCase().includes(search.toLowerCase()) ||
        item.MOBILE?.includes(search)
    );

    // Export PDF
    const handleExportPdf = () => {
        const input = document.getElementById('customer-table');
        Loading.arrows('Generating Multi-Page PDF...');
        html2canvas(input, { scale: 2 })
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('l', 'mm', 'a4');
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgProps = pdf.getImageProperties(imgData);
                const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
                let heightLeft = imgHeight;
                let position = 0;

                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, imgHeight);
                heightLeft -= pdfHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
                    heightLeft -= pdfHeight;
                }

                pdf.save(`Customer_Online_Data_${shopType === '1' ? 'Wineshop' : 'Beerbar'}_NotUpdated.pdf`);
                Loading.remove();
            })
            .catch((error) => {
                console.error('PDF Export Error:', error);
                Loading.remove();
            });
    };

    // Export Excel
    const handleExportExcel = () => {
        Loading.arrows('Generating Excel...');
        const dataForExcel = filteredNews.map((item, index) => ({
            'SR NO': index + 1,
            'SHOP NAME': item.SHOP_NAME,
            'CUSTOMER NAME': item.NAME,
            'MOBILE': item.MOBILE,
            'LAST TRANSACTION': item.LAST_TRANSACTION,
            'TRANSACTION DATE': formatDate(item.tran_date)
        }));

        const ws = XLSX.utils.json_to_sheet(dataForExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Customer Data");
        XLSX.writeFile(wb, `Customer_Online_Data_${shopType === '1' ? 'Wineshop' : 'Beerbar'}_NotUpdated.xlsx`);
        Loading.remove();
    };

    return (
        <div className='container mt-4'>
            <div className="card-body">
                <div className="text-center my-4">
                    <h2>Pranali InfoTech</h2>
                    <p>Customer Online DataBase Management System</p>
                </div>

                {/* Selection + Search + Export Buttons */}
                <div className="mb-3 d-flex flex-wrap justify-content-between align-items-center gap-2">

                    {/* Selection Box (Beerbar First) */}
                    <select
                        className="form-select"
                        style={{ width: '200px' }}
                        value={shopType}
                        onChange={(e) => setShopType(e.target.value)}
                    >
                        <option value="2">🍺 Beerbar</option>
                        <option value="1">🍷 Wineshop</option>
                    </select>

                    {/* Search Input */}
                    <input
                        type="text"
                        className="form-control"
                        style={{ maxWidth: '300px' }}
                        placeholder="Search by Shop, Name or Mobile"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    {/* Export Buttons */}
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-success"
                            onClick={handleExportExcel}
                            disabled={filteredNews.length === 0}
                        >
                            Export Excel
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={handleExportPdf}
                            disabled={filteredNews.length === 0}
                        >
                            Export PDF
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div className="table-responsive">
                    <table className="table table-bordered table-striped" id="customer-table">
                        <thead className="table-dark">
                            <tr>
                                <th>SR NO</th>
                                <th>SHOP NAME</th>
                                <th>CUSTOMER NAME</th>
                                <th>MOBILE</th>
                                <th>LAST TRANSACTION</th>
                                <th>TRANSACTION DATE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredNews.map((value, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{value.SHOP_NAME}</td>
                                    <td>{value.NAME}</td>
                                    <td>{value.MOBILE}</td>
                                    <td>{value.LAST_TRANSACTION}</td>
                                    <td>{formatDate(value.tran_date)}</td>
                                </tr>
                            ))}
                            {filteredNews.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="text-center text-danger">
                                        No records found with missing transaction date.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default FetchNews;
